import { disableBodyScroll, enableBodyScroll } from '@/utils/dom'
import { makeAutoObservable } from 'mobx'

export class PopupStore {
  isVisible = false

  needDisableScroll = true

  constructor({
    isVisible,
    needDisableScroll,
  }: {
    isVisible?: boolean
    needDisableScroll?: boolean
  } = {}) {
    if (isVisible != null) {
      this.isVisible = isVisible
    }
    if (this.needDisableScroll != null) {
      this.needDisableScroll = needDisableScroll
    }
    makeAutoObservable(this, {}, { autoBind: true })
  }

  show() {
    this.isVisible = true
    if (this.needDisableScroll) {
      disableBodyScroll()
    }
  }

  hide() {
    this.isVisible = false
    if (this.needDisableScroll) {
      enableBodyScroll()
    }
  }

  toggle() {
    if (this.isVisible) {
      this.hide()
    } else {
      this.show()
    }
  }
}
